import { OverviewData } from "../overview/overviewUtil";
import axios from "axios";
import { LitterDensityData } from "../litterDensity/litterDensityUtil";
import { MaterialsAndProducts } from "../materialAndProduct/materialAndProductUtil";
import { LocationData } from "../location/locationStoreUtil";
import { SurveyStatsData } from "../surveyStats/surveyStatsUtil";
import { ApiFilterData } from "../util";
import { FilterApiData } from "../filter/filterUtil";

export async function getOverviewData(data: ApiFilterData): Promise<OverviewData> {
  const response = await axios({ method: "post", url: "/api/Overview", data });
  if (response.status === 200) return response.data;
  throw new Error("Could not get overview data");
}

export async function getLitterDensityData(data: ApiFilterData): Promise<LitterDensityData> {
  const response = await axios({ method: "post", url: "/api/LitterDensity", data });
  if (response.status === 200) return response.data;
  throw new Error("Could not get litter density data");
}

export async function getMaterialsAndProducts(data: ApiFilterData): Promise<MaterialsAndProducts[]> {
  const response = await axios({ method: "post", url: "/api/MaterialsAndProducts", data });
  if (response.status === 200) return response.data;
  throw new Error("Could not get materials and data");
}

export async function getLocationData(data: ApiFilterData): Promise<LocationData> {
  const response = await axios({ method: "post", url: "/api/Location", data });
  if (response.status === 200) return response.data;
  throw new Error("Could not get location data");
}

export async function getSurveyStatsData(data: ApiFilterData): Promise<SurveyStatsData> {
  const response = await axios({ method: "post", url: "/api/SurveyStats", data });
  if (response.status === 200) return response.data;
  throw new Error("Could not get survey Stats Data");
}

export async function getFilterData(): Promise<FilterApiData> {
  const response = await axios({ method: "GET", url: "/api/Filter" });
  if (response.status === 200) return response.data;
  throw new Error("Could not get Filter Data");
}



